import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=0ba058e0&scoped=true&"
import script from "./afterSale.vue?vue&type=script&lang=js&"
export * from "./afterSale.vue?vue&type=script&lang=js&"
import style0 from "./afterSale.vue?vue&type=style&index=0&lang=css&"
import style1 from "./afterSale.vue?vue&type=style&index=1&id=0ba058e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba058e0",
  null
  
)

export default component.exports